import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import {
  CustomAutocomplete,
  CustomTextArea,
  EstadoComponente,
  GeneralTable,
  TabTextLabel,

} from "@/shared/components/ui";
import { useFetchMotivosRechazo, useGetSolicitudesIngreso, useGetSolicitudIngreso, useUpdateSolicitudesIngresos } from "@/shared/actions/erp";
import { useCheckPermissions, useTableFilter, useTableServerSideFiltering, useUploadFile } from "@/shared/hooks";
import {
  AlertSeverityEnum,
  EstadosSolicitudIngresoEnum,
  MaterialTransferido,
  MotivoRechazo,
  SolicitudesIngreso,
} from "@/shared/interfaces";
import { Grid, IconButton, Paper, Tooltip } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { PermissionsEnum } from "@/auth/interfaces";


import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useUiStore } from "@/store/ui";
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import { BucketAwtENUM, cellNotFilter, formatDateWithTimeCell, gridSize, gridSizeMdLg4, gridSizeMdLg6, ModulosEnumChoice, ROUTER_PATHS, TABLE_CONSTANTS_COLUMS } from "@/shared";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import CustomCantidadRecibidaInput from "@/shared/components/ui/CustomCantidadRecibidaInput";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import CargarDocumentoSoluccionCosteada from "@/erp/venta-corporativa/solucion_costeada/shared/componente/cargar_documento_soluccion_costeada/CargarDocumentoSoluccionCosteada";
import SmartTextArea from "@/shared/components/ui/SmartTextArea";
import ModalObservacionGeneral from "@/shared/components/ui/ModalObservacionesGeneral";
// import { useMaterialesUtilizadosStore } from "@/store/erp";

export default function SolicitudIngresoEnEsperaPagina() {
  useCheckPermissions(PermissionsEnum.api_change_solicitudingreso)

  const navigate = useNavigate();
  //*
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  const setPaginationTableProducto = useCargarSeriesProductos(s => s.setPagination)
  const paginationTableProducto = useCargarSeriesProductos(s => s.pagination)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  //const returUrlComprasUsuarios = "/compras/revision-solicitud-compra"
  const returUrlComprasUsuarios = ROUTER_PATHS.compras.solicitud_ingreso_revision_nav
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const [idEdit, setIdEdit] = useState<string | null>(null);
  const [idEdit1, setIdEdit1] = useState<string | null>(null)
  const [isModalOpen, setIsModalOpen] = useState(false);
  //const [details, setDetails] = useState<IDataProducto[]>([]);
  const [/* isVisibility1 */, setIsVisibility1] = useState(false)
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [idSolicitudIngreso, setIdSolicitudIngreso] = useState(false)
  const [archivo, setArchivo] = useState<File | null>(null)





  const { data: dataSolicitudIngreso } = useGetSolicitudIngreso(idEdit!)

  const updateSolicitudesIngreso = useUpdateSolicitudesIngresos({
    navigate,
    returnUrl: returUrlComprasUsuarios
  })

  const { handleUploadFile } = useUploadFile()

  ///Aprobar // update
  const onSaveEdit = async () => {

    try {
      if (idEdit) {
        const campoInvalido = productos.find(item => item.cantidad_aprobada! <= 0 || isNaN(item.cantidad_aprobada!))
        if (campoInvalido) {
          setAlert(true, `El producto "${campoInvalido.codigo}" tiene una cantidad aprobada inválida, debe ser mayor a cero .`, AlertSeverityEnum.error);
          return;
        }
        const obs = form.getValues().observaciones?.observacionSolicitante
        const observacionSolicitante = obs === 'N/A' ? '' : obs
        /*        const revisionSolicitudIngreso: any = {
                  id: idEdit,
                  data: {
                    estado_solicitud: EstadosSolicitudIngresoEnum.APROBADAS,
                    productos: productos,
                    observaciones: {
                      observacionSolicitante: observacionSolicitante,
                      observacionRevision: form.getValues().observaciones?.observacionRevision
                    }
                  }
                }
                console.log('json', revisionSolicitudIngreso)
                return   */
        const isImage = archivo?.type.startsWith("image/")
        const bucketDestino = isImage
          ? BucketAwtENUM.IMAGE_REVISION_SOLIICTUD_COMPRA
          : BucketAwtENUM.DOCUMENTO_REVISION_SOLICITUD_COMPRA

        const archivoRevision = (await handleUploadFile(archivo!, bucketDestino)).url;
        const urlsActual = dataSolicitudIngreso?.data.urls_imagenes || {}
        updateSolicitudesIngreso.mutate(
          {
            id: idEdit!,
            data: {
              estado_solicitud: EstadosSolicitudIngresoEnum.APROBADAS,
              productos: productos,
              observaciones: {
                observacionSolicitante: observacionSolicitante,
                observacionRevision: form.getValues().observaciones?.observacionRevision
              },
              urls_imagenes: {
                ...urlsActual,
                archivoRevision: archivoRevision
              }

            }
          },
          {
            onSuccess: () => {
              setIsModalOpen(false);
              form.reset({ observaciones: { observacionSolicitante: '' } });
              refetch();
              handleGenerarOrdenCompra();
              setArchivo(null)

            },
            onError: (error: any) => {
              console.error("Error en la mutación", error)
            }
          }
        )
      } else {
        console.error("idEdit is null");
      }
    } catch (error) {
      console.error("Error en la mutación", error)
    }
  }
  //rechazo
  const handleConfirm = () => {
    if (form.getValues().motivo_rechazo === "") {
      setAlert(true, "Seleccione un motivo, para proceder con la confirmación.", AlertSeverityEnum.error)
      return;
    }
    const obs = form.getValues().observaciones?.observacionSolicitante
    const observacionSolicitante = obs === 'N/A' ? '' : obs

    setConfirmDialog({
      isOpen: true,
      subtitle: "¿Está seguro que deseas rechazar el orden de compra seleccionado?",
      title: "Confirmar el Rechazo",

      onConfirm: () => {
        try {
          setIsModalOpen3(true)

          if (idEdit1) {
            updateSolicitudesIngreso.mutate(
              {
                id: idEdit1!,
                data: {
                  estado_solicitud: EstadosSolicitudIngresoEnum.RECHAZADO,
                  motivo_rechazo: form.getValues().motivo_rechazo,
                  observaciones: {
                    observacionSolicitante: observacionSolicitante,
                    observacionRevision: form.getValues().observaciones?.observacionRevision
                  },
                }
              },
              {
                onSuccess: () => {
                  setIsModalOpen(false);
                  setConfirmDialogIsOpen(false);
                  setIsModalOpen3(false);
                  form.reset({ motivo_rechazo: " " })
                  refetch()

                },
                onError: (error: any) => {
                  console.error("Error en la mutación", error)
                }
              }


            )
          } else {
            console.error("idEdit is mull")
          }
        } catch (error) {
          console.error("Error en la mutación")

        }
      },
      onClose() {
        setConfirmDialogIsOpen(false)
        setIsModalOpen(false)
        setIsModalOpen3(false)
        refetch();
      },
    })
  }
  ///modal deseas generar
  const handleGenerarOrdenCompra = () => {
    setConfirmDialog({
      isOpen: true,
      title: "¡Aprobado con éxito!",
      subtitle: "La solicitud de compra se ha aprobado correctamente, el próximo paso es generar un Orden de compra.¿Te gustaría continuar?",
      onConfirm() {
        setConfirmDialogIsOpen(false);
        return navigate(`/compras/orden-compras/crear/${idSolicitudIngreso}`)
      },
      onClose() {
        setConfirmDialogIsOpen(false)
      },
    })

  }

  type SaveFormData = {
    observaciones?: {
      observacionSolicitante: string;
      observacionRevision: string;
    }

    motivo_rechazo: string;
  }
  const form = useForm<SaveFormData>();
  const {
    control,
    formState: { errors },

  } = form;


  useEffect(() => {
    if (!isModalOpen3) {
      form.setValue('motivo_rechazo', '')
    }

  }, [isModalOpen3, form.setValue])

  const { data: MotivoRechazoPaging, isLoading: isLoadingMotivoRechazo } =
    useFetchMotivosRechazo({
      page_size: 600,
      modulo: ModulosEnumChoice.COMPRAS
    })

  const onChangeMotivoRechazo = (value: string) => {
    form.setValue("motivo_rechazo", value)
  }
  ///alert
  const setAlert = useUiStore((s) => s.setAlert);
  ///

  const columns = useMemo<MRT_ColumnDef<SolicitudesIngreso>[]>(
    () => [
      {
        accessorKey: "numero_referencia",
        header: "numero referencia",
        size: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_creacion",
        header: "fecha de creacion",
        size: 200,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion')
      },

      {
        ...cellNotFilter,
        accessorKey: "bodega_data.nombre",
        header: "bodega",
        size: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "ubicacion_data.nombre",
        header: "ubicacion",
        size: 200,
      },
      {
        accessorKey: 'observaciones.observacionSolicitante',
        header: "Observación Solicitante",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        //size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => {
          return (
            <ModalObservacionGeneral
              texto={
                row.original.observaciones?.observacionSolicitante || 'N/A'
              }
              title="Observación Solicitante"
            />
          )
        }
      },
      /* {
        accessorKey: "observaciones.observacionSolicitante",
        header: "observaciones",
        size: 200,
        Cell: ({ row }) => row.original?.observaciones?.observacionSolicitante || 'N/A'

      }, */
      {
        ...cellNotFilter,
        accessorKey: "user.username",
        header: "Usuario",
        size: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "estado_solicitud",
        header: "estado",
        size: 200,
        Cell: ({ row }) =>
          row.original.estado_solicitud != null ? (
            <EstadoComponente
              backgroundColor="#FFC107"
              texto={row.original.estado_solicitud || ""}
            />
          ) : null,
      },
    ],
    []
  );

  const AgregarCantidad = (productos: MaterialTransferido[]) => {
    /*  productos.(()) */

    const resp = productos.map((elemento) => ({
      ...elemento,
      cantidad_aprobada: Number(elemento.cantidad_aprobada ?? elemento.cantidad)
    }))
    handleCopiarLista(resp)
  }
  const onDetails = (e: MRT_RowData) => {
    AgregarCantidad(e.productos)

    form.setValue('observaciones.observacionSolicitante', e?.observaciones.observacionSolicitante || 'N/A');
    //handleCopiarLista(e.productos)
    setIdEdit(e.id_solicitudingreso)
    setIdEdit1(e.id_solicitudingreso)
    setIdSolicitudIngreso(e.id_solicitudingreso)
    setIsModalOpen(true);
    setIsVisibility1(false);
  };
  console.log(onDetails)
  const columnsProductosDetallePedidosDb: MRT_ColumnDef<MaterialTransferido>[] =
    useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
      () => [
        {
          accessorKey: 'cantidad',
          header: 'Cant. Requerida'
        },

        {
          accessorKey: 'cantidad_aprobada',
          header: 'Cant. a  Aprobar',

          Cell: ({ row }) => {
            const cantidadMaxima = Number(row.original.cantidad)
            return (
              <CustomCantidadRecibidaInput
                value={Number(row.original.cantidad_aprobada) || 0}
                maxValue={cantidadMaxima}
                handleValue={(value) => {
                  handleActualizarProducto(row.original.id, {
                    ...row.original,
                    cantidad_aprobada: value
                  })
                }}
                row={row}
              />
            )
          }
        },

        {
          accessorKey: 'codigo',
          header: 'Código',
          Cell: ({ row }) => row.original?.codigo || 'N/A',
        },
        {
          accessorKey: 'producto_data.descripcion',
          header: 'Descripción',
        },
        {
          accessorKey: 'producto_data.unidad_medida',
          header: 'Unidad Medida',
          Cell: ({ row }) => row.original?.producto_data?.unidad_medida || 'N/A'
        },
        {
          accessorKey: 'producto_data.stock_actual',
          header: 'Stock Actual',
        },
        {
          accessorKey: 'producto_data.modelo_producto',
          header: 'Modelo',
        },
        {
          accessorKey: 'producto_data.marca_producto',
          header: 'Marca',
        },
        {
          accessorKey: 'producto_data.categoria_producto',
          header: 'Categoria',
        },
      ],
      []
    );

  const {

    pagination,
    searchTerm,
    setPagination,
    dateBefore,
    dateAfter,

  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;
  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering();

  const {
    data: solicitudPedidoIngresosEnesperaRes,
    isLoading,
    isRefetching,
    refetch
  } = useGetSolicitudesIngreso({
    page_size: pageSize,
    page: pageIndex + 1,
    estado_solicitud: EstadosSolicitudIngresoEnum.ESPERA,
    fecha_after: dateAfter,
    fecha_before: dateBefore,
    numero_referencia: searchTerm,
    ...filterObject,
    filterByState: false,
  });


  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<SolicitudesIngreso>
          columns={columns}
          data={solicitudPedidoIngresosEnesperaRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={solicitudPedidoIngresosEnesperaRes?.data?.count}
          // crud
          enableColumnActions={true}
          //
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          ///curd
          canDelete={false}
          positionActionsColumn="first"
          canEdit={false}
          enableEditing={true}

          showCustomActionBtnSpace={true}
          customActionBtnSpace={(value) => {
            return (
              <>
                <Grid container>
                  <Grid item>
                    <Tooltip title="Aprobar/Rechazar" placement={'top'}>
                      <IconButton
                        onClick={() => {
                          //onDetails(value); 
                          //setIsVisibility1(true)
                          navigate(`${ROUTER_PATHS.compras.solicitud_ingreso_revision_editar.replace(':id', String(value.id_solicitudingreso))}`)
                        }}
                      >
                        <NoteAltIcon fontSize='medium' />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>

              </>
            )
          }}
        />
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Productos"

        confirmTextBtn="Aprobar"
        confirmBtnColor="success"
        confirmVariantBtn="contained"
        minWidth='75%'
        minHeight='90%'
        onConfirm={() => { onSaveEdit() }}
        onCloseIcon={() => { setIsModalOpen(false), form.setValue('observaciones.observacionRevision', ''), clearSelectedItems() }}

        showConfirmBtn={true}
        showRejectBtn={true}

        onReject={() => { setIsModalOpen3(true) }}
        rejectVariantBtn={'outlined'}
        rejectBtnColor="error"


        contentNode={
          <Grid container spacing={3}>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <SampleTablePagination
                columns={columnsProductosDetallePedidosDb}
                data={paginatedData}
                rowCount={productos.length}
                pagination={paginationTableProducto}
                setPagination={setPaginationTableProducto}
              //rowNumber={true}
              />
            </Grid>

            <Grid item {...gridSize}>
              <Paper className="paper-producto">
                <Grid container spacing={3} justifyContent={'space-between'} alignItems={'center'}>

                  <CustomTextArea
                    label="Observación"
                    name="observaciones.observacionRevision"
                    defaultValue={form.getValues().observaciones?.observacionRevision}
                    control={form.control}
                    error={errors.observaciones?.observacionRevision}
                    helperText={errors.observaciones?.observacionRevision?.message}
                    size={gridSizeMdLg6}
                    rows={2}
                    required={false}
                  />
                  <SmartTextArea
                    label="Observación Solicitante (Bodega) *"
                    name="observaciones.observacionSolicitante"
                    control={form.control}
                    texto={form.getValues().observaciones?.observacionSolicitante || 'N/A'}
                    title="Observación"
                    size={gridSizeMdLg6}
                    rows={2}
                    maxPreviewWords={50}
                  //disabled={true}
                  />
                  {/*  <CustomTextArea
                    label="Observación del solicitante (Bodega)"
                    name="observaciones.observacionSolicitante"
                    defaultValue={form.getValues().observaciones?.observacionSolicitante || 'N/A'}
                    control={form.control}
                    error={errors.observaciones?.observacionSolicitante}
                    helperText={errors.observaciones?.observacionSolicitante?.message}
                    size={gridSizeMdLg6}
                    rows={3}
                    disabled={true}
                  /> */}


                  {/*  <CustomTextField
                    label="Observacion"
                    name="observaciones.observacionRevision"
                    defaultValue={form.getValues().observaciones?.observacionRevision}
                    control={form.control}
                    error={errors.observaciones?.observacionRevision}
                    helperText={errors.observaciones?.observacionRevision?.message}
                    size={gridSizeMdLg6}
                  /> */}
                  {/*  <CustomTextField
                    label="Observación del solicitante (Bodega) "
                    name="observaciones.observacionSolicitante"
                    defaultValue={form.getValues().observaciones?.observacionSolicitante || 'N/A'}
                    required={false}
                    control={form.control}
                    error={errors.observaciones?.observacionSolicitante}
                    helperText={errors.observaciones?.observacionSolicitante?.message}
                    size={gridSizeMdLg6}
                    disabled={true}
                  /> */}
                  <Grid item xs={12}>
                    <TabTextLabel text={'Respaldo de aprobación'} mt={0} pb={0} pl={0} pt={2} />
                  </Grid>
                  <Grid item {...gridSizeMdLg4}>
                    <CargarDocumentoSoluccionCosteada
                      idInput='documento-solicitud_compra'
                      buttonText={'Respaldo de Aprobación'}
                      selectedImage={archivo}
                      setSelectedImage={setArchivo}
                      accept=".pdf, .png, .jpg, .jpeg"
                      tiposPermitidos={["application/pdf", "image/*"]}
                      permiteImagen={true}
                    />
                  </Grid>
                </Grid>

              </Paper>
            </Grid>
            <Grid>

            </Grid>

            {/*otro*/}
          </Grid>
        }
      />
      <ScrollableDialogProps
        open={isModalOpen3}
        title="Rechazar la solicitud"
        cancelTextBtn="Cancelar"
        //confirmTextBtn="Rechazar"
        showRejectBtn={true}
        rejectVariantBtn={'outlined'}
        rejectBtnColor="error"
        onReject={handleConfirm}
        onCloseIcon={() => setIsModalOpen3(false)}
        contentNode={
          <>
            <CustomAutocomplete<MotivoRechazo>
              label="Motivo"
              name="motivo_rechazo"
              //options
              options={(MotivoRechazoPaging?.data.data as any) || []}
              valueKey="nombre"
              actualValueKey="codigo"
              defaultValue={form.getValues().motivo_rechazo || ""}
              isLoadingData={isLoadingMotivoRechazo}
              control={control}
              error={errors.motivo_rechazo}
              helperText={errors.motivo_rechazo?.message}
              onChangeValue={onChangeMotivoRechazo}
              optionLabelForEdit={
                MotivoRechazoPaging?.data.data.find((a) =>
                  a.codigo === form.getValues().motivo_rechazo)
                  ?.id_motivo_rechazo?.toString() || ""
              }

            />

          </>
        }
        //onConfirm={handleConfirm}
        onClose={() => { setIsModalOpen3(false) }}
      />
    </Grid>
  );
}

